// src/pages/ManageApiKey/states/manageApiKeySlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IManageApiKeyState {
	loading: boolean;
	error: string | null;
}

const initialState: IManageApiKeyState = {
	loading: false,
	error: null,
};

const manageApiKeySlice = createSlice({
	name: "manageApiKeySlice",
	initialState,
	reducers: {
		setLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
		},
	},
});

export const { setLoading, setError } = manageApiKeySlice.actions;
export default manageApiKeySlice.reducer;
